import React, { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DoubleToDegree, timezones } from '../Common/Util';
import Title from '../Login/LoginUtil';
import { axiosGetWithHeader, ShowAlertError } from '../Common/axios';
import Spinner from 'react-bootstrap/esm/Spinner';

export function Profile (props) {
  const [data, setData] = useState([]);
  const [comdata, setComData] = useState([]);
  const [errorAlert, setErrorAlert] = useState(null);
  const [spinner, setSpinner] = useState('Loading - Profile Page');
  const navigate = useNavigate();

  useMemo(() => {
    axiosGetWithHeader("/astrologer/view",
      (response)=>{
        setData(response.data);
      },
      (error)=>{
        console.log(error);
        setErrorAlert(error.message);
      }
    );

    axiosGetWithHeader("/astrologer/getMobileAndEmail",
      (response)=>{
        setComData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );
  }, []);

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/home.html', { replace: true });
    }, 100);
  }

  var timezoneValue=timezones.find(element=>{return element.value===data.timezone; });
  if(typeof  timezoneValue==="undefined" ){timezoneValue=timezones.find(element=>{return element.value==="5.5"; });}

  return(
    <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        <div class="m-0 p-0 row align-items-top">
            <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
            <div class="m-0 p-0 col-sm-12 col-md-8 bg-white text-black">
            <Title title="My Profile" urlcallback={handleBack}></Title>
    
              <div class="card m-3">
                <div class="card-header">
                  <div class="clearfix">
                    <div class="float-start"><span class="h4">Personal Details</span></div>
                    <div class="float-end"><Link to="/cprofile.html" class="text-decoration-none">edit</Link></div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-4 col-md-3 col-lg-2">Name</div><div class="col-8 col-md-9 col-lg-10">: {data.firstName} {data.lastName}</div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-3 col-lg-2">Address</div><div class="col-8 col-md-9 col-lg-10">: {data.address}</div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-3 col-lg-2">City</div><div class="col-8 col-md-9 col-lg-10">: {data.city}</div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-3 col-lg-2">Timezone</div><div class="col-8 col-md-9 col-lg-10">: {timezoneValue.label}</div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-3 col-lg-2">Latitude</div><div class="col-8 col-md-9 col-lg-10">: {(data.latitude===null || data.latitude==="")?<></>:<><DoubleToDegree value={data.latitude}/> ( {data.latitude} )</> }</div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-3 col-lg-2">Longitude</div><div class="col-8 col-md-9 col-lg-10">: {(data.longitude===null || data.longitude==="")?<></>:<><DoubleToDegree value={data.longitude}/> ( {data.longitude} )</> }</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-lg-6">
    
                  <div class="card m-3">
                    <div class="card-header">
                      <div class="clearfix">
                        <div class="float-start"><span class="h4">Communication</span></div>
                        <div class="float-end"><Link to="/ccom.html" class="text-decoration-none">edit</Link></div>
                      </div>
                    </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-3">Email</div><div class="col-9">: {comdata.email}</div>
                    </div>
                    <div class="row">
                      <div class="col-3">Mobile</div><div class="col-9">: {comdata.mobile}</div>
                    </div>
                  </div>
                </div>
                  
              </div>
              <div class="col-sm-12 col-lg-6">
                <div class="card m-3">
                  <div class="card-header">
                    <div class="clearfix">
                      <div class="float-start"><span class="h4">Security</span></div>
                      <div class="float-end"></div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4 ">Current Pin</div><div class="col-8">: xxxxxxxx <Link to="/cpin.html" class="text-decoration-none">edit</Link></div>
                    </div>
                    <div class="row">
                      <div class="col-4">Current Password</div><div class="col-8">: xxxxxxxx <Link to="/cpass.html" class="text-decoration-none">edit</Link></div>
                    </div>
                  </div>
                </div>
                <br/>
            </div>
          </div>
      </div>
      
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div> 
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
        </div>   
    </>
  );
}
